import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const LocationsQuery = graphql(/* GraphQL */ `
  query locations($offset: Int, $limit: Int) {
    locations(offset: $offset, limit: $limit) {
      ...LocationsPaged
    }
  }
`);
